import { priceInCurrency, formatCurrencyAmount } from "utils";

export const enabled = (value) => value === true || value === 1 || value === "1";

export const isInPersonalLibrary = (book) => {
	if (book.in_personal_library != null) return enabled(book.in_personal_library);
	// Older responses can grant reading access through in_library (e.g. administrators).
	return enabled(book.in_picks) || enabled(book.is_gifted)
		|| (enabled(book.is_purchased) && book.format_purchased_in !== "physical");
};

export const catalogueBookDetails = (book, currency) => {
	const free = enabled(book.isFree);
	const amount = priceInCurrency(book.prices, currency, book.price, book.zwl_price);
	return {
		free,
		inLibrary: isInPersonalLibrary(book),
		format: { digital: "Digital", physical: "Print", both: "Digital + print" }[book.format],
		price: free ? "Free" : enabled(book.sellable) && Number(amount) > 0
			? formatCurrencyAmount(amount, currency) : enabled(book.subscription) ? "Subscription" : "View access",
	};
};

export const catalogueBookPath = (book, location) => {
	// Keep the existing continue-shopping URL format used by book details.
	const query = new URLSearchParams(location.search).toString().replace(/&/g, "lgAnd").replace(/-/g, "lgHyphen");
	const returnUrl = location.pathname + (query ? `lgQuestionMark${query}` : "");
	return `/book/${book.id}?returnUrl=${encodeURIComponent(returnUrl)}`;
};
